export default __webpack_public_path__ + "static/media/options.08323f9f.svg";